export default {
  ADD_USER(state, user) {
    if (user.birthDate) {
      let date = new Date(user.birthDate);
      let day = date.getDate() < 10 ? '0' + date.getDate(): date.getDate();

      let month = date.getMonth()+1 < 10 ? '0' + (date.getMonth()+1):(date.getMonth()+1);
      let year = date.getFullYear();
      user.birthDate = day + "/" + month + "/" + year;
    }

    user.fullName = user.name + " " + user.surname;
    user.userRoles = "";
    user.role.forEach(function (role, index) {
      user.userRoles += role.name;
      if (index != user.role.length - 1) user.userRoles +=
        ", ";
    });
    state.users.unshift(user);
    state.totalDataRow++;
  },
  SET_USERS(state, res) {
    res.items = res.items.map((data) => {
      data.fullName = data.name + " " + data.surname;
      data.userRoles = "";
      data.role.forEach(function (role, index) {
        data.userRoles += role.name;
        if (index != data.role.length - 1) data.userRoles +=
          ", ";

      });
      if (data.birthDate) {
        data.birthDate = data.birthDate.substring(0, 10);
        let parts = data.birthDate.split("-");
        data.birthDate = parts[2] + "/" + parts[1] + "/" + parts[0];
      }
      return data;
    });
    state.users = res.items
    state.totalDataRow = res.totalCount;
  },
  UPDATE_USER(state, user) {
    user.fullName = user.name + " " + user.surname;
    user.userRoles = "";
    user.role.forEach(function (role, index) {
      user.userRoles += role.name;
      if (index != user.role.length - 1) user.userRoles +=
        ", ";
    });
    if (user.birthDate) {
      user.birthDate = user.birthDate.substring(0, 10);
      let parts = user.birthDate.split("-");
      user.birthDate = parts[2] + "/" + parts[1] + "/" + parts[0];
    }

    const userIndex = state.users.findIndex((p) => p.id == user.id)
    Object.assign(state.users[userIndex], user)
  },
  REMOVE_USER(state, userId) {
    const userIndex = state.users.findIndex((p) => p.id == userId)
    state.users.splice(userIndex, 1)
  },
}
